/**
 * Capitalizes the first letter of a string and lowercases the rest.
 *
 * @param value - The string to capitalize.
 * @returns The capitalized string, or an empty string if the input is falsy.
 *
 * @example
 * capitalize('hello')   // 'Hello'
 * capitalize('WORLD')   // 'World'
 * capitalize('')        // ''
 */
export function capitalize(value: string): string {
  if (!value) {
    return '';
  }
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}
